/**
 * VoucherBatchSubscriberLink entity class
 */

/**
 * VoucherBatchSubscriberLinkFactory
 * returns VoucherBatchSubscriberLink entity class
 *
 * @class VoucherBatchSubscriberLinkFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.VoucherBatchSubscriberLink} class
 *
 * @ngdoc factory
 * @name mwApp.factory:VoucherBatchSubscriberLinkFactory
 */
/* @ngInject */
export default function VoucherBatchSubscriberLinkFactory (Entity) {
  /* === VoucherBatchSubscriberLink class === */

  /**
   * VoucherBatchSubscriberLink model
   *
   * @class VoucherBatchSubscriberLink
   * @classdesc VoucherBatchSubscriberLink model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @param {Object} [object] - initial object, containing VoucherBatchSubscriberLink entity fields
   * @return {models.VoucherBatchSubscriberLink} VoucherBatchSubscriberLink entity
   */
  function VoucherBatchSubscriberLink () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  VoucherBatchSubscriberLink.prototype = Object.create(Entity.prototype)
  VoucherBatchSubscriberLink.prototype.constructor = VoucherBatchSubscriberLink

  /* === VoucherBatchSubscriberLink instance methods & fields === */

  Object.assign(VoucherBatchSubscriberLink.prototype, {

    /**
     * instance fields
     *
     * @memberof models.VoucherBatchSubscriberLink#
     * @type {Object}
     */
    _fields: {
      id: Number,
      sold: Boolean,
      voucherBatch: 'VoucherBatch',
      subscriber: 'Subscriber'
    }

  })

  /* === VoucherBatchSubscriberLink static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(VoucherBatchSubscriberLink, Entity)
  VoucherBatchSubscriberLink._name = 'VoucherBatchSubscriberLink'
  VoucherBatchSubscriberLink.init()

  return VoucherBatchSubscriberLink
}
